module.exports = __webpack_public_path__ + "img/header_features.13502f69.svg";